const MESSAGE_AUTHOR_TYPES = {
  agent: "agent",
  customer: "customer",
};

export default MESSAGE_AUTHOR_TYPES;
